export default "__VITE_ASSET__BSfjWdPb__"